import styled from "@emotion/styled";
import { Button } from "../Button";

export const RowItems = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const RowItem = styled.div`
  min-width: 22rem;
  flex: 1 1 22rem;
  margin-top: 13px;
  margin-left: 2rem;
  max-width: calc(100% - 2rem);

  @media ${(props) => props.theme.bp.mobileUp} {
    margin-top: 23px;
  }
`;

export const FormItem = styled.div`
  flex: 1 1 22rem;
  margin-top: 13px;
  margin-left: 2rem;
  max-width: calc(100% - 2rem);

  @media ${(props) => props.theme.bp.mobileUp} {
    margin-top: 23px;
  }
`;

export const FormLayout = styled.div`
  margin-left: -2rem;
`;

export const FormButton = styled(Button)`
  margin-top: 35px;
`;
